import React, { useContext } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box"; 
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";  
import { UserContext } from "../../auth/auth-context";

const ColorButton = styled((props) => <Button variant="outlined" {...props} />)({
  height: "50px",
  border: "none",
  "&:hover": {
    border: "none", 
  },
});
 
const BookingTypeEntryFormHeader = (props) => {
  const userContext = useContext(UserContext);
  const providerUser = userContext.providerUser; 

  return (
    <Box> 
      <Box sx={{ width: "100%", overflowY: "auto" }}>
        <ColorButton
          href={"/biz/bookingtypes" 
          }
          startIcon={<ChevronLeftIcon />}
        >
          Back
        </ColorButton>
        <props.display
          {...props}
          currentStaffId={providerUser.staffId}
          providerUser={providerUser}
          details={providerUser}
        />
      </Box>
    </Box>
  );
};

export default BookingTypeEntryFormHeader;
